<!--
 * @Date: 2024-03-22 13:18:49

-->
<template>
  <bk-page 
		:class="{
			'pointsPage':true,
			['pointsPage-kisDZFlag']:kisDZFlag,
			['pointsPage-oblissDZFlag']:oblissDZFlag,
			['pointsPage-komoDZFlag']:komoDZFlag,
		}" 
		pageType="navPage" 
		:navBarInfo="navBarInfo"
	>
		<template #slot-rightItems>
			<bk-button type="text" v-if="showPointsRules" class="view-rules" @click="setShowPage('pointsRules')">
				<bk-lang code="points_detail_rules"></bk-lang>
				<bk-icon icon="icon-youjiantou"></bk-icon>
			</bk-button>
		</template>
    
		<bk-view class="view-box">
      <bk-view class="points-header">
        <bk-view v-if="chainList?.length" class="chain-view" @click="show = true">
          <bk-icon icon="icon-a-Component87" />
          <bk-view class="overflowText">{{ custItem?.custName }}</bk-view>
          <bk-icon icon="icon-youjiantou"></bk-icon>
        </bk-view>
        <bk-view class="point-view">
          <bk-lang code="userInfo_point_title"></bk-lang>
          <bk-title>{{ totalPoints }}</bk-title>
        </bk-view>
        <bk-view class="view-image"></bk-view>
      </bk-view>

      <bk-view class="points-wrapper" v-if="custItem">
        <bk-view class="points-title-view">
          <bk-lang code="points_details_title"></bk-lang>
        </bk-view>
        <bk-scroll-list
          :key="custItem.custId"
          :beforeSearch="beforeSearch"  
          :async-load-data="getDataList" >
          <template v-slot="{ dataList }">
            <points-item v-for="item in dataList" :key="item.id" :pointItem="item"></points-item>
          </template>
        </bk-scroll-list>
      </bk-view>
    </bk-view>
    

    <bk-picker
      :show="show"
      :dataList="chainList"
      :fields="{ key: 'custId', keyName: 'custName' }"
      @close="show = false"
      @confirm="handleConfirm">
    </bk-picker>

		<transition name="rightFadeIn">
      <pointsRules v-if="showPage==='pointsRules'" :curRows="custItem" @close="setShowPage()" />
    </transition>
    
  </bk-page>
</template>
  
<script>
	import { customerReq, baseReq } from '@r';
	import PointsItem from './components/pointsItem.vue';
	import PointsRules from './subViews/pointsRules/pointsRules.vue';

	export default {
		name: 'Points',
		components: { PointsItem, PointsRules },
		data () {
			this.navBarInfo = {
				langCode_title:'userInfo_point_title',
				backFlag: true,
			};
			return {
				shopDetailInfo:this.$bk_getShopDetailInfo(),
				kisDZFlag: window.kisDZFlag,
				oblissDZFlag: window.oblissDZFlag,
				komoDZFlag:window.komoDZFlag,
				userInfo:this.$bk_getUserInfo(),
				totalPoints: 0,
				show: false,
				chainList: [],
				custItem: null,
				showPage:'',
				showPointsRules:false,
			};
		},

		methods: {
			setShowPage (showPage='') { 
				this.showPage = showPage;
			},
			async requestGetPointRuleList (){
				const { custId } = this.custItem;
				const resRule = await baseReq.requestGetPointRuleList(this, { custId, compCode:'001' });
				const { status, content	} = resRule['PR013'] || {};
				this.showPointsRules = status==1 && content; 
			},

			beforeSearch (params) {
				const { custId } = this.custItem;
				params.userId = this.userInfo.id;
				params.custId = custId;

				return params;
			},

			async getAvailableChainList () {
				let res = await customerReq.requestGetMemberAvailableChainList(this);

				if(res?.length && (window.kisDZFlag || window.oblissDZFlag || window.komoDZFlag)){
					res = res.filter((item) => {
						return item.custId === this.shopDetailInfo?.custId; 
					});	
				}
				
				this.chainList = res;
				if(res?.length){
					this.custItem = res[0] || {};
					this.requestGetPointRuleList();
				}
			},

			async getDataList (params) {
				const res = await customerReq.requestGetMemberPointsData(this, params);
				this.totalPoints = res?.totalPoints || 0;
      
				return { data:res?.detailList, total: res?.detailList.length };
			},

			handleConfirm (item) {
				this.custItem = item;
				this.show = false;
				this.requestGetPointRuleList();
			}
		},

		mounted () {
			this.getAvailableChainList();
		}
	};
</script>
  
<style lang='less'>
@import './points.less';
</style>
